import PageLayout from '@/components/feature/PageLayout';
import Reviews from '@/pages/home/components/Reviews';

export default function ReviewsPage() {
  return (
    <PageLayout>
      <Reviews />
    </PageLayout>
  );
}